export default __webpack_public_path__ + "media/verify_user_account_email/title_locale_de-fb7a91f3.png";